import { useState } from 'react'
import Swal from 'sweetalert2'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'

import { useApiCustomRequest } from '../../../../customHooks/useApiCustomRequest'
import { useAuthentication } from '../../../../customHooks/useAuthentication'
import { useModalHook } from '../../../../customHooks/useModalHook'
import { SIGNUP_LIFECYCLE_CODES } from '../../../Account/lifecycle/lifecycle.constants'
import { extractLifecycleCode, extractLifecycleMessage } from '../../../Account/lifecycle/lifecycle.utils'

export const useForm = (initalForm, validateForm, typeRequest = 'signUp') => {
  const history = useHistory()
  useLocation()
  const { formatMessage: trans } = useIntl()

  const { saveItemInLocalStorage, deleteItemFromLocalStorage } = useAuthentication()

  const { showSuccessButton, showModal, setShowModal, customTittleText, customMessageModal, cancelButtonText, sucessButtonText, manageResponseErrors, manageResponse, manageSuccessfullMesssage } = useModalHook()

  const { isLoading, createItemDetail } = useApiCustomRequest(manageResponseErrors, 'register', 'User', manageResponse, manageSuccessfullMesssage, true, () => {})

  const [form, setForm] = useState(initalForm)
  const [errors, setErrors] = useState({})
  const [loading] = useState(false)
  const [response] = useState(null)
  const [manageResponseMessage, setManageResponseMessage] = useState({
    status: true,
    message: '',
    showRedirectButton: false,
  })
  const [lifecycleNotice, setLifecycleNotice] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
    if (name === 'email') setLifecycleNotice(null)
    setErrors((prev) => {
      if (!prev?.[name]) return prev
      const next = { ...prev }
      delete next[name]
      return next
    })
  }

  const handleBlur = (e) => {
    handleChange(e)
    // setErrors(validateForm(form));
  }

  const handleSubmit = async (e, url = '', reSend = false, requestData = {}) => {
    e.preventDefault()

    if (isLoading) return

    let newErrors = []

    if (!reSend) {
      newErrors = validateForm(form)
    }

    setErrors(newErrors)

    if (Object.keys(newErrors).length === 0) {
      if (typeRequest === 'signUp') {
        const { phone_ext, phone_number, ...extForm } = form

        let requestBody = {
          ...extForm,
          phone_number: phone_ext + phone_number,
          email_send: true,
          sms_send: false,
        }

        let response = await createItemDetail(requestBody, 'User', 'register', true, 'creating', true, true)

        const lifecycleCode = extractLifecycleCode(response)
        if (SIGNUP_LIFECYCLE_CODES.has(lifecycleCode)) {
          setLifecycleNotice({ code: lifecycleCode, message: extractLifecycleMessage(response) })
          setErrors({})
        } else if (response && response.status === false) {
          const errors = {}
          if (response.errors?.email) errors.email = Array.isArray(response.errors.email) ? response.errors.email[0] : response.errors.email
          else if (extractLifecycleMessage(response)) errors.email = extractLifecycleMessage(response)
          setErrors(errors)
        }

        if (response && response.hasOwnProperty('status') && response.status) {
          saveItemInLocalStorage('item_validation_info', {
            email: form.email,
            phoneNumber: phone_ext + phone_number,
          })

          history.push({
            pathname: '/validation_selection',
            search: ``,
          })
        }
      }

      if (typeRequest === 'ValidateCode') {
        let requestUrl = reSend ? url : 'validate_code'

        let requestBody = {}

        if (!reSend) {
          requestBody = {
            ...form,
            ...requestData,
          }
        } else {
          requestBody = {
            ...requestData,
          }
        }

        let response = await createItemDetail(requestBody, 'Code', requestUrl, true, 'validating', true, true)

        if (response?.status && !reSend) {
          await Swal.fire({
            icon: 'success',
            title: trans({ id: 'signup_email_verified_title', defaultMessage: 'Email verified!' }),
            text: trans({
              id: 'signup_email_verified_text',
              defaultMessage: 'Your email was verified successfully. You can sign in with your account now.',
            }),
            confirmButtonColor: '#e8601c',
            confirmButtonText: trans({ id: 'signup_go_to_login', defaultMessage: 'Go to login' }),
          })
          deleteItemFromLocalStorage('item_validation_info')
          history.push('/')
          return
        }

        setManageResponseMessage({
          ...response,
          showRedirectButton: !reSend ? true : false,
        })
      }

      if (typeRequest === 'SendCode') {
        let requestBody = {
          ...requestData,
        }

        let response = await createItemDetail(requestBody, 'Code', url, true, 'validating', true, true)

        setManageResponseMessage({ ...response })

        if (response && response.hasOwnProperty('status') && response.status) {
          history.push({
            pathname: '/validation_code',
            search: ``,
          })
        }
      }
    } else {
      return
    }
  }
  return {
    form,
    errors,
    lifecycleNotice,
    loading,
    response,
    handleChange,
    handleBlur,
    handleSubmit,
    showSuccessButton,
    showModal,
    setShowModal,
    customTittleText,
    customMessageModal,
    cancelButtonText,
    sucessButtonText,
    manageResponseErrors,
    manageResponse,
    manageSuccessfullMesssage,
    isLoading,
    manageResponseMessage,
  }
}
